import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import SensorTab from "./SensorTab";
import CustomerTab from "./CustomerTab";
import CustomerLookupTab from "./CustomerLookupTab";

export default function SensorLookup() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("sensor");
  const [searchTui, setSearchTui] = useState("");

  const handleSelectSensor = (tui) => {
    setSearchTui(tui);
    setActiveTab("sensor");
  };

  return (
    <div className="sensor-lookup">
      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
        <Tab eventKey="sensor" title={t("sensor_events")}>
          <SensorTab searchTui={searchTui} setSearchTui={setSearchTui} />
        </Tab>

        <Tab eventKey="customer" title={t("manage_customers") || "Manage Customers"}>
          <CustomerTab onSelectSensor={handleSelectSensor} />
        </Tab>

        <Tab eventKey="customer_lookup" title={t("customer_details") || "Customer Details"}>
          <CustomerLookupTab onSelectSensor={handleSelectSensor} />
        </Tab>
      </Tabs>
    </div>
  );
}
